export default "__VITE_ASSET__BHmrS$EQ__"